<template>
   <!-- ================= FOOTER ================= -->
    <footer class="max-w-[1440px] mx-auto px-12 py-16 border-t border-slate-100
         flex flex-col md:flex-row justify-between items-center gap-8">

      <!-- Left : Brand -->
      <div class="flex items-center gap-2">
        <img src="/images/logo.png" style="height: 2.5rem;">
      </div>

      <!-- Center : Footer Links -->
      <div class="flex gap-10 text-[10px] font-bold uppercase
           tracking-[0.2em] text-slate-300">
        <a v-for="link in footerLinks" :key="link" :href="link.url" target="_blank" class="hover:text-slate-900 transition-colors">
          {{ link.title }}
        </a>
      </div>

      <!-- Right : Copyright -->
      <p class="text-[10px] font-bold text-slate-300 tracking-tight">
        © {{ currentYear }}. ALL RIGHTS RESERVED.
      </p>

    </footer>
</template>

<script>


export default {
  name: "AnalyticsPage",
  data() {
    return {
       footerLinks: [
          {
            title: "Privacy Policy",
            url: "https://inflorix.com/privacy.php"
          },
          {
            title: "Terms",
            url: "https://inflorix.com/terms.php"
          },
           {
            title: "Security",
            url: "https://inflorix.com/security.php"
          },
        ],
        currentYear: new Date().getFullYear(),
    }
  },
 
};
</script>

